import { render } from "./ProductDetail.vue?vue&type=template&id=0ddea1d8&scoped=true&ts=true"
import script from "./ProductDetail.vue?vue&type=script&lang=ts"
export * from "./ProductDetail.vue?vue&type=script&lang=ts"

import "./ProductDetail.vue?vue&type=style&index=0&id=0ddea1d8&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ddea1d8"]])

export default __exports__